<template>
    <div class="designerpage">

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Location</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control" value="Retail Door">

        <swc-designer-question-door-range v-if="range_panel_required"
                                         :fabricator="fabricator"
                                         v-model:target="door.attr.door_range"
                                         :ranges="ranges"
                                         :defaults="defaults()"
                                         title="Please select a Door Collection"
                                         :reference_on="reference_on"></swc-designer-question-door-range>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              v-model:target="door.attr.slab"
                                              title="Select Door Slab Style"
            ></wb-designer-question-select-door>
        </div>

        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>

            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <swc-designer-question-select-frame-style :fabricator="fabricator"
                                                      :is-firedoor="is_firedoorrange"
                                                      v-model:target="door.attr.frame_style"></swc-designer-question-select-frame-style>


        <div v-show="technical_should_show">
            <swc-designer-question-measurements title="Enter Your Required Measurements"
                                                :fabricator="fabricator"
                                                :slab="door.attr.slab"
                                                :door-range="door.attr.door_range"
                                                :external-colour="door.attr.external_colour"
                                                :internal-colour="door.attr.door_colour_internal"
                                                :frame-profile="door.attr.profile"
                                                :threshold="door.attr.threshold"
                                                :frame-id="door.attr.frame_style.frame_id"
                                                :side-panels="door.attr.side_panels"
                                                :addons="door.attr.addons"
                                                :couplers="door.attr.couplers"
                                                :cill="door.attr.cill"
                                                :hardware-lock="door.attr.hardware_lock"
                                                :hardware-hinge="door.attr.hardware_hinge"
                                                :hardware-handle="door.attr.hardware_handle"
                                                :hardware-knocker="door.attr.hardware_knocker"
                                                :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                :hardware-letterbox="door.attr.hardware_letterbox"
                                                :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                :mdd="mdd"
                                                :technical_should_show="technical_should_show"
                                                v-model:target="door.attr.measurements">

            </swc-designer-question-measurements>
        </div>

        <div class="row">
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="frame_colour_external">

                    <h3>Choose Your External Frame Colour</h3>

                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                v-model:target="door.attr.frame_colour_external"
                                                                :maintitle="''"
                    ></wb-designer-question-frame-colour-external>
                </div>
            </div>
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="frame_colour_internal">

                    <h3>Choose Your Internal Frame Colour</h3>

                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                v-model:target="door.attr.frame_colour_internal"
                                                                :maintitle="''"
                    ></wb-designer-question-frame-colour-internal>
                </div>
            </div>
        </div>

        <div v-show="technical_should_show">
            <swc-designer-question-technical-profile :fabricator="fabricator"
                                                     :frame-colour-internal="door.attr.frame_colour_internal"
                                                     :frame-colour-external="door.attr.frame_colour_external"
                                                     :frame-material="door.attr.frame_material"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                     :opening-direction="door.attr.opening_direction"
                                                     v-model:target="door.attr.profile"
                                                     :title="'Profile Suite - Changing this may reset selections below'"
            ></swc-designer-question-technical-profile>
        </div>

        <div class="designeroption">
            <swc-designer-question-secured-by-design :fabricator="fabricator"
                                                     v-model:target="door.attr.secured_by_design"></swc-designer-question-secured-by-design>
        </div>

        <div class="designeroption">
            <designer-question-colour-range title="Colour Ranges"
                                            :fabricator="fabricator"
                                            :secured-by-design="door.attr.secured_by_design"
                                            v-model:target="door.attr.door_colour_range">
            </designer-question-colour-range>
        </div>

        <div class="row">
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="external_colour">

                    <h3>Choose Your External Door Colour</h3>

                    <designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :colour-range="door.attr.door_colour_range"
                                                               v-model:target="door.attr.external_colour"></designer-question-door-colour-external>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                      title="External Door Colour"
                                                      v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="door_colour_internal">

                    <h3>Choose Your Internal Door Colour</h3>

                            <designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                                       :external-colour="door.attr.external_colour"
                                                                       :colour-range="door.attr.door_colour_range"
                                                                       v-model:target="door.attr.door_colour_internal"></designer-question-door-colour-internal>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                      title="Internal Door Colour"
                                                      v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="technical_should_show">
            <designer-question-technical-threshold :fabricator="fabricator"
                                                   title="Choose Your Threshold"
                                                   v-model:target="door.attr.threshold"
                                                   :opening-direction="door.attr.opening_direction"
                                                   :frame-profile="door.attr.profile"
                                                   :door-range="door.attr.door_range"
                                                   :cill="door.attr.cill"
                                                   :title="''"
                                                   :maintitle="'Choose Your Threshold'"
            ></designer-question-technical-threshold>
        </div>

        <div class="designeroption" data-designer-component-id="threshold_ramp" v-show="technical_should_show">
            <h3>Threshold Ramp</h3>

            <div class="stylesoption">
                <div class="row">
                    <div class="col">
                        <designer-question-technical-ramp title="External Ramp"
                                                          v-model:target="door.attr.ramp.external"
                                                          :fabricator="fabricator"
                                                          :profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          :threshold="door.attr.threshold">
                        </designer-question-technical-ramp>
                    </div>
                    <div class="col">
                        <designer-question-technical-ramp title="Internal Ramp"
                                                          v-model:target="door.attr.ramp.internal"
                                                          :fabricator="fabricator"
                                                          :profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          :threshold="door.attr.threshold">
                        </designer-question-technical-ramp>
                    </div>
                </div>
            </div>
        </div>

        <div class="designeroption" v-show="technical_should_show">
            <h3>Select Any Required Cills</h3>
            <designer-question-technical-cill v-if="!is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :ramp-internal="door.attr.ramp.internal"
                                              :ramp-external="door.attr.ramp.external"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill && !is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :ramp-internal="door.attr.ramp.internal"
                                              :ramp-external="door.attr.ramp.external"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill && !is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :ramp-internal="door.attr.ramp.internal"
                                              :ramp-external="door.attr.ramp.external"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>
        </div>

        <designer-question-technical-drainage :fabricator="fabricator"
                                              v-model:target="door.attr.drainage"
                                              :cill="door.attr.cill"
                                              :threshold="door.attr.threshold"></designer-question-technical-drainage>

        <div v-show="technical_should_show">
            <designer-question-addons :fabricator="fabricator"
                                      v-model:target="door.attr.addons"
                                      :frame-profile="door.attr.profile"
                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                      :frame-colour-external="door.attr.frame_colour_external">

            </designer-question-addons>
        </div>

        <div>
            <swc-designer-question-door-glass-laminated :fabricator="fabricator"
                                                       :frame-style="door.attr.frame_style"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :side-panels="door.attr.side_panels"
                                                       :slab="door.attr.slab"
                                                       v-model:target="door.attr.laminated_glass"
                                                       title="Laminated Glass:"></swc-designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></wb-designer-question-glass-design>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <swc-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                      v-model:target="door.attr.side_panels"
                                                      :door-range="door.attr.door_range"
                                                      :frame-style="door.attr.frame_style"
                                                      :frame-profile="door.attr.profile"
                                                      :frame-material="door.attr.frame_material"
                                                      :laminated-glass="door.attr.laminated_glass"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :slab="door.attr.slab"
                                                      :measurements.sync="door.attr.measurements"></swc-designer-question-select-frame-sidepanels>

        <div>
            <wb-designer-question-hardware-colour :door-range="door.attr.door_range"
                                                  :fabricator="fabricator"
                                                  :hardware-suite="door.attr.suite"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :profile="door.attr.profile"
                                                  :sbd="door.attr.secured_by_design"
                                                  :slab="door.attr.slab"
                                                  v-model:target="door.attr.hardware_colour"></wb-designer-question-hardware-colour>
            <div class="designeroption stylesoption mt-0" style="border-top:0;">
                Any changes may affect the door hardware choices you may have already made below.
            </div>
        </div>

        <div>
            <wb-designer-question-hardware-handle :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"></wb-designer-question-hardware-handle>

            <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle_split_spindle"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>

            <wb-designer-question-hardware-handle-internal :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_handle_internal"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :opening-direction="door.attr.opening_direction"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :door-range="door.attr.door_range"
                                                           :profile="door.attr.profile"
                                                           :handle-external="door.attr.hardware_handle"></wb-designer-question-hardware-handle-internal>
        </div>

        <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_decorative_handle"
                                                      :slab="door.attr.slab"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :door-range="door.attr.door_range"></designer-question-hardware-decorative-handle>

        <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                               v-model:target="door.attr.hardware_decorative_handle_pos"
                                                               :slab="door.attr.slab"
                                                               :frame-material="door.attr.frame_material"
                                                               :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>

        <div>
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>

        <div>
            <designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                                :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                             :door-range="door.attr.door_range"
                                             :title="''"
                                             :maintitle="'Choose Your Lock'"
            ></designer-question-hardware-lock>


            <designer-question-hardware-cylinder-tiled v-show="technical_should_show" :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    :slab="door.attr.slab"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-cylinder-tiled>

            <designer-question-hardware-cylinder-guard v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_cylinder_guard"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-cylinder="door.attr.hardware_cylinder"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-cylinder-guard>


        </div>

        <div>
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     title="Add A Mailbox"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
        </div>

        <div>
            <wb-designer-question-hardware-knocker :door-range="door.attr.door_range"
                                                   :fabricator="fabricator"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :slab="door.attr.slab"
                                                   v-model:target="door.attr.hardware_knocker"></wb-designer-question-hardware-knocker>

            <wb-designer-question-hardware-knocker-position :door-range="door.attr.door_range"
                                                            :fabricator="fabricator"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-knocker="door.attr.hardware_knocker"
                                                            :slab="door.attr.slab"
                                                            v-model:target="door.attr.hardware_knocker_pos"></wb-designer-question-hardware-knocker-position>
        </div>

        <div>
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    title="Choose A Spyhole"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>
        </div>
        <div>
            <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_hinge"
                                                 :slab="door.attr.slab"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :frame-material="door.attr.frame_material"
                                                 :door-range="door.attr.door_range"></wb-designer-question-hardware-hinge>

            <designer-question-hardware-hinge-bolts v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_hinge_bolts"
                                                       :hardware-hinge="door.attr.hardware_hinge"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-hinge-bolts>
        </div>

        <div v-show="technical_should_show">
            <designer-question-restrictor :fabricator="fabricator"
                                          v-model:target="door.attr.restrictor"></designer-question-restrictor>


        </div>

        <div v-show="technical_should_show">
            <designer-question-technical-coupler :fabricator="fabricator"
                                      v-model:target="door.attr.couplers"
                                      :frame-profile="door.attr.profile"
                                      :frame-combination="door.attr.frame_style.frame_id"
                                      :title="'Select Coupler size'">

            </designer-question-technical-coupler>
        </div>

      <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        props:{
            door_colour_filter: {
                default() {
                    return '';
                }
            },
            frame_colour_filter: {
                default() {
                    return '';
                }
            },
        },
        computed: {
            is_firedoorrange(){
                return false;
                //return this.door.attr.door_range === 22;
            },
        },
        methods: {
          defaults() {
            return {
              71: {
                "attr": {
                  "fabricator": 18,
                  "door_range": 71,
                  "door_colour_range": 5,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 644,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 972,
                  "hardware_hinge": 370,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1068,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 6,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 7856,
                  "threshold": 7863,
                  "ramp": {"internal": 144073, "external": 144073},
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "hardware_handle_split_spindle": 424,
                  "couplers": {"sides": null, "top": null},
                  "hardware_decorative_handle": 1112
                }
              },
            };
          },
        }
    }
</script>
